// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand-link: var(--text-link, #1a6da3);

  --widget-bg: #ffffff;
  --widget-border: var(--border-subtle, #e2e8f0);
  --widget-border-strong: var(--border-default, #cbd5e1);
  --widget-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
  --widget-shadow-hover: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));

  --text-strong-local: var(--text-strong, #0f172a);
  --text-main: var(--text-body, #334155);
  --text-muted-local: var(--text-muted, #64748b);

  --line-soft: var(--border-subtle, #e2e8f0);
  --line-mid: var(--border-default, #cbd5e1);

  --pill-blue-bg: var(--blue-50, #eef6fc);
  --pill-blue-border: var(--blue-100, #d4e8f6);
  --pill-blue-border-strong: var(--border-default, #cbd5e1);
  --pill-blue-border-hover: var(--blue-300, #6fb1df);

  --cta-shadow: none;
  --cta-shadow-hover: 0 4px 12px rgba(34, 126, 189, 0.28);
}

/* ==========================================================================
   1) DASHBOARD LAYOUT
   ========================================================================== */

.dashboard-viewport {
  width: 100%;
  margin-top: 0 !important;
  padding: 0 0 28px;
  box-sizing: border-box;
  background: var(--surface-page, #f8fafc);
}

.dashboard {
  width: 100%;
  max-width: none;
  margin: 0;
}

.dashboard-intro {
  display: flex;
  width: calc(100% + 48px);
  min-height: 86px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: -20px 0 18px -24px;
  padding: 14px 72px 14px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.dashboard-introTitle {
  font-family: var(--font-heading, var(--font-display, inherit));
  font-size: 22px;
  line-height: 1.1;
  font-weight: 800;
  color: var(--text-strong);
  letter-spacing: -0.015em;
}

.dashboard-introSubtitle {
  margin-top: 5px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--text-muted);
}

.dashboard-setupLink {
  flex: 0 0 auto;
  border: 1px solid #b8c9d8;
  border-radius: 8px;
  background: #fff;
  padding: 9px 13px;
  color: #195f8d;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.dashboard-setupLink:hover,
.dashboard-setupLink:focus {
  border-color: #3687b7;
  background: #eef7fc;
  color: #174f77;
  text-decoration: none;
}

@media (max-width: 1217px) {
  .dashboard-intro {
    width: 100vw;
    margin-top: -16px;
    margin-left: -12px;
    padding-right: 28px;
  }
}

@media (max-width: 640px) {
  .dashboard-intro {
    align-items: flex-start;
    flex-direction: column;
  }

  .dashboard-setupLink {
    width: 100%;
    text-align: center;
  }
}

.dashboard-widget-list {
  display: block;
  width: 100%;
  column-width: 304px;
  column-gap: var(--space-5, 16px);
}

.dashboard-widget-list--muuri {
  position: relative;
  display: block;
  column-width: auto;
  column-gap: 0;
  min-height: 360px;
  transition: height var(--dur-base, 0.18s) var(--ease-out, ease);
}

.dashboard-item {
  min-width: 0;
  box-sizing: border-box;
  display: inline-block;
  width: 100%;
  margin: 0 0 var(--space-5, 16px);
  break-inside: avoid;
}

.dashboard-widget-list--muuri .dashboard-item {
  position: absolute;
  display: block;
  width: 304px;
  margin: 0 16px 16px 0;
  z-index: 1;
  break-inside: auto;
}

.dashboard-widget-list--muuri .dashboard-item.muuri-item-dragging {
  z-index: 4;
}

.dashboard-widget-list--muuri .dashboard-item.muuri-item-releasing {
  z-index: 3;
}

.dashboard-widget-list--muuri .dashboard-item.muuri-item-hidden {
  z-index: 0;
}

.dashboard-item > div {
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.dashboard-widget-list--muuri .dashboard-item.muuri-item-dragging .widget {
  box-shadow: var(--shadow-lg, 0 12px 28px rgba(15, 23, 42, 0.12));
  border-color: var(--border-brand, #227ebd);
  transform: none;
}

.dashboard-widget-list--muuri .dashboard-item .muuri-item-placeholder {
  border-radius: var(--radius-md, 8px);
  border: 1px dashed var(--border-brand, #227ebd);
  background: var(--blue-50, #eef6fc);
}

@media (min-width: 1500px) {
  .dashboard-widget-list {
    column-width: 320px;
  }

  .dashboard-widget-list--muuri .dashboard-item {
    width: 320px;
  }
}

@media (max-width: 760px) {
  .dashboard-viewport {
    padding: 0 0 24px;
  }

  .dashboard-intro {
    width: 100vw;
    min-height: 76px;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    margin: -16px 0 14px -16px;
    padding: 12px 16px;
  }

  .dashboard-introTitle {
    font-size: 20px;
  }

  .dashboard-widget-list {
    column-width: auto;
  }

  .dashboard-widget-list--muuri .dashboard-item {
    width: 100%;
    margin-right: 0;
  }
}

.dashboardPager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 10px;
}

.dashboardPagerBtn {
  width: 28px;
  height: 28px;
  border: 1px solid var(--line-mid);
  border-radius: 999px;
  background: #fff;
  color: var(--text-main);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.dashboardPagerBtn:hover:not(:disabled) {
  background: rgba(34, 126, 189, 0.06);
  border-color: rgba(34, 126, 189, 0.18);
  color: var(--brand-link);
}

.dashboardPagerBtn:disabled {
  opacity: 0.4;
  cursor: default;
}

.dashboardPagerText {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-muted);
  min-width: 42px;
  text-align: center;
}

/* ==========================================================================
   2) WIDGET SHELL
   ========================================================================== */

.widget {
  background: var(--widget-bg);
  border: 1px solid var(--widget-border);
  border-radius: var(--radius-md, 8px);
  box-shadow: var(--shadow-sm, var(--widget-shadow));
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  width: 100%;
  overflow: hidden;
}

.widget-header {
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--line-soft);
  background: #ffffff;
}

.widget-header::before {
  display: none !important;
}

.widget-headerMain {
  cursor: grab;
  touch-action: none;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1 auto;
}

.dashboard-widget-list--dragging .widget-headerMain {
  cursor: grabbing;
}

.widget-titleWrap {
  min-width: 0;
  flex: 1 1 auto;
}

.widget-header h4 {
  margin: 0;
  min-width: 0;
  font-size: 15px;
  line-height: 1.2;
  font-weight: 800;
  color: var(--text-strong, #0f172a);
}

.widget-drag-handle {
  pointer-events: none;
  pointer-events: none;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md, 8px);
  border: 1px solid rgba(15, 23, 42, 0.06);
  background: rgba(255, 255, 255, 0.72);
  cursor: grab;
  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.widget-drag-handle:hover {
  background: #fff;
  border-color: rgba(34, 126, 189, 0.14);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.dashboard-widget-list--muuri .dashboard-item.muuri-item-dragging .widget-header {
  cursor: grabbing;
}

.widget-drag-handle:active {
  cursor: grabbing;
}

.widget-dragIcon {
  width: 12px;
  height: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px;
}

.widget-dragIcon span {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #94a3b8;
  display: block;
}

.widget-remove {
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  border: 1px solid var(--line-mid);
  border-radius: var(--radius-md, 8px);
  background: rgba(15, 23, 42, 0.03);
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
}

.widget-remove:hover {
  background: rgba(239, 68, 68, 0.08);
  color: #b91c1c;
  border-color: rgba(239, 68, 68, 0.16);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.08);
}

.widget-drag-handle:focus,
.widget-remove:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);
}

.widget:hover {
  box-shadow: var(--widget-shadow-hover);
  border-color: var(--widget-border-strong);
  transform: translateY(-1px);
}

.widget-header::before {
  display: none !important;
}

.widget-content {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  padding: 14px 16px 16px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}

.widget .widget-content a,
.widget .widget-content a:link,
.widget .widget-content a:visited {
  color: var(--brand-link) !important;
  text-decoration: none;
}

.widget .widget-content a:hover,
.widget .widget-content a:focus,
.widget .widget-content a:active {
  color: var(--brand-link) !important;
  text-decoration: underline;
}

/* ==========================================================================
   3) COMMON EVENT / FIXTURE / TOURNAMENT LISTS
   ========================================================================== */

.fixtures-widget,
.week-fixtures-widget,
.clubs-widget,
.upcoming-tournaments-widget {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.fixtures-list-area,
.week-fixtures-list-area,
.clubs-list-area,
.upcoming-tournaments-list-area {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.fixtures-footer,
.week-fixtures-footer,
.clubs-footer,
.upcoming-tournaments-footer {
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid var(--line-soft);
  display: flex;
  justify-content: flex-end;
}

.dashboardEventList,
.tournaments-list {
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.dashboardEventList li,
.tournaments-list li {
  border-bottom: 1px solid var(--line-soft);
}

.dashboardEventList li:last-child,
.tournaments-list li:last-child {
  border-bottom: none;
}

/* today fixtures / clubs */
.dashboardEventRow {
  display: grid;
  grid-template-columns: 64px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  min-width: 0;
  padding: 10px 0;
  text-decoration: none;
}

.dashboardEventRow:hover {
  background: rgba(34, 126, 189, 0.05);
  border-radius: var(--radius-md, 8px);
}

.dashboardEventTime {
  font-size: 13px;
  font-weight: 800;
  color: var(--brand-link);
  white-space: nowrap;
}

.dashboardEventName {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-strong);
  line-height: 1.25;
}

/* upcoming tournaments */
.upcoming-tournament-row {
  display: grid !important;
  grid-template-columns: 84px minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 10px 0;
}

.upcoming-tournament-dateBlock {
  min-width: 0;
  padding: 8px 10px;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fbff, #eef6fb);
  border: 1px solid rgba(34, 126, 189, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.upcoming-tournament-date {
  font-size: 13px;
  font-weight: 800;
  line-height: 1.15;
  color: var(--brand-link);
}

.upcoming-tournament-time {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-main);
}

.upcoming-tournament-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.upcoming-tournament-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  color: var(--text-strong);
}

.upcoming-tournament-meta {
  margin-top: 2px;
  font-size: 12px;
  color: var(--text-muted);
  line-height: 1.3;
}

/* ==========================================================================
   4) EMPTY STATE
   ========================================================================== */

.widget-empty-state {
  padding: 12px 2px 6px;
}

.widget-empty-stateTitle {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-main);
}

.widget-empty-stateText {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-muted);
}

/* ==========================================================================
   5) SCHOOL DETAILS CARD
   ========================================================================== */

.school-card-widget {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.school-card-top {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.school-logo-wrapper,
.school-logo-wrapper--large {
  width: 92px;
  height: 92px;
  overflow: hidden;
  border-radius: 20px;
  background: linear-gradient(180deg, #ffffff, #f5f8fb);
  border: 1px solid var(--line-mid);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  flex: 0 0 auto;
}

.school-logo-wrapper img,
.school-logo-wrapper--large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.school-card-main {
  min-width: 0;
  flex: 1 1 auto;
}

.school-card-eyebrow {
  font-size: 11px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 6px;
}

.school-card-title {
  margin: 0 0 10px;
  font-size: 18px;
  line-height: 1.15;
  font-weight: 800;
  color: var(--text-strong);
}

.school-card-title a {
  color: inherit !important;
  text-decoration: none !important;
}

.school-card-title a:hover {
  text-decoration: underline !important;
}

.school-card-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.school-card-badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--pill-blue-bg);
  color: var(--brand-link);
  border: 1px solid var(--pill-blue-border);
  font-size: 12px;
  font-weight: 700;
}

.school-card-badge--subtle {
  background: #f8fafc;
  color: var(--text-main);
  border-color: var(--line-mid);
}

.school-card-badge--action {
  background: #f8fbff;
  color: var(--brand-link) !important;
  border: 1px solid var(--pill-blue-border-strong);
  text-decoration: none !important;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.school-card-badge--action:hover {
  background: #eef6fb;
  border-color: var(--pill-blue-border-hover);
  text-decoration: none !important;
  transform: translateY(-1px);
}

.school-card-body {
  border-top: 1px solid var(--line-soft);
  padding-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.school-card-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.school-card-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.school-card-value {
  color: var(--text-main);
  line-height: 1.5;
  word-break: break-word;
}

.school-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* ==========================================================================
   6) PROFILE CARD
   ========================================================================== */

.profile-card-widget {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.profile-card-top {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.profile-avatar,
.profile-avatar--large {
  width: 92px;
  height: 92px;
  overflow: hidden;
  border-radius: 50%;
  flex: 0 0 auto;
  background: linear-gradient(180deg, #ffffff, #f5f8fb);
  border: 1px solid var(--line-mid);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

.profile-avatar img,
.profile-avatar--large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.profile-card-main {
  min-width: 0;
  flex: 1 1 auto;
}

.profile-card-eyebrow {
  font-size: 11px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 6px;
}

.profile-card-title {
  margin: 0 0 10px;
  font-size: 18px;
  line-height: 1.15;
  font-weight: 800;
  color: var(--text-strong);
}

.profile-card-title a {
  color: inherit !important;
  text-decoration: none !important;
}

.profile-card-title a:hover {
  text-decoration: underline !important;
}

.profile-card-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.profile-card-badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--pill-blue-bg);
  color: var(--brand-link);
  border: 1px solid var(--pill-blue-border);
  font-size: 12px;
  font-weight: 700;
}

.profile-card-badge--subtle {
  background: #f8fafc;
  color: var(--text-main);
  border-color: var(--line-mid);
}

.profile-card-badge--action {
  background: #f8fbff;
  color: var(--brand-link) !important;
  border: 1px solid var(--pill-blue-border-strong);
  text-decoration: none !important;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;
}

.profile-card-badge--action:hover {
  background: #eef6fb;
  border-color: var(--pill-blue-border-hover);
  text-decoration: none !important;
  transform: translateY(-1px);
}

.profile-card-body {
  border-top: 1px solid var(--line-soft);
  padding-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.profile-card-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.profile-card-label {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.profile-card-value {
  color: var(--text-main);
  line-height: 1.5;
  word-break: break-word;
}

.profile-card-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* ==========================================================================
   7) IMPORTANT WIDGET
   ========================================================================== */

.important-events-widget {
  display: grid;
  gap: 10px;
  padding: 2px 0;
}

.important-events-list {
  display: grid;
  gap: 10px;
}

.widget .important-event-card,
.widget .important-event-card:link,
.widget .important-event-card:visited {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid var(--line-mid);
  background: linear-gradient(180deg, #ffffff, #fbfdff);
  color: var(--text-strong) !important;
  text-decoration: none !important;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.widget .important-event-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
  border-color: rgba(34, 126, 189, 0.18);
  text-decoration: none !important;
}

.important-event-cardCount {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-grid;
  place-items: center;
  background: #f97316;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 4px 10px rgba(249, 115, 22, 0.25);
}

.important-event-cardBody {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.important-event-cardTitle {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-strong);
  line-height: 1.2;
}

.important-event-cardMeta {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.35;
}

.important-event-cardArrow {
  color: var(--text-muted);
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}

/* ==========================================================================
   8) STATISTICS
   ========================================================================== */

.statistics-widget {
  --stat-bg: linear-gradient(180deg, #ffffff, #f8fbff);
  --stat-bd: rgba(15, 23, 42, 0.06);
  --stat-muted: #94a3b8;
  --stat-pill-bg: rgba(34, 126, 189, 0.1);
  --stat-pill-txt: #1f5f91;

  padding: 0;
  border: 1px solid var(--stat-bd);
  border-radius: 14px;
  background: var(--stat-bg);
}

.statistics-widget .statistics-list {
  display: grid;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.eventCommunications-widget .statistics-list {
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
}
.eventCommunications-widget {
  display: flex;
  min-height: 0;
  flex-direction: column;
  gap: 14px;
}
.statistics-widget.eventCommunications-widget .stat-row {
  min-width: 0;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 10px 12px;
}
.eventCommunications-widget .stat-main {
  min-width: 0;
}
.statistics-widget.eventCommunications-widget .field-label {
  min-width: 0;
  font-size: 12px;
  line-height: 1.3;
  overflow-wrap: normal;
  word-break: normal;
  white-space: normal;
}
.eventCommunications-widget .stat-value {
  min-width: 36px;
  flex: 0 0 auto;
}
.eventCommunications-widget > .primary-cta-btn {
  position: static;
  z-index: auto;
  width: 100%;
  min-height: 38px;
  flex: 0 0 auto;
  margin: 0;
}
.eventCommunications-widget--unavailable {
  justify-content: center;
  min-height: 150px;
  text-align: center;
}
.eventCommunications-widget--unavailable p {
  margin: 0;
  color: #69768c;
  font-size: 13px;
  line-height: 1.5;
}
.eventCommunications-widget .statistics-list > li {
  list-style: none;
}
.eventCommunications-widget .stat-row {
  width: 100%;
  color: inherit;
  background: #fff;
  text-align: left;
  cursor: pointer;
}
.eventCommunications-widget .stat-row.is-muted {
  color: #94a3b8;
  background: #fafbfc;
}
.eventCommunications-widget .stat-row.is-pending .stat-value {
  color: #a85c07;
  background: #ffe9c2;
}
.eventCommunications-widget .stat-row.is-reported .stat-value {
  color: #a52836;
  background: #f9d4d9;
}
.eventCommunications-widget__group {
  padding: 4px 3px 0;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.statistics-widget .stat-row {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--stat-bd);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.statistics-widget .stat-row:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  border-color: rgba(34, 126, 189, 0.14);
}

.statistics-widget .stat-icon {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: color-mix(in srgb, var(--brand-link) 10%, #fff);
  border: 1px solid var(--stat-bd);
  color: var(--brand-link);
  flex: 0 0 32px;
}

.statistics-widget .stat-icon svg {
  width: 18px;
  height: 18px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.statistics-widget .stat-row.is-zero .stat-icon {
  color: var(--text-muted);
  background: #f8fafc;
}

.statistics-widget .stat-main {
  min-width: 0;
  display: flex;
  align-items: center;
}

.statistics-widget .field-label {
  margin: 0;
  min-width: 0;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 700;
  color: var(--text-strong);
  word-break: break-word;
}

.statistics-widget .stat-value {
  min-width: 40px;
  padding: 6px 10px;
  border-radius: 999px;
  background: var(--stat-pill-bg);
  color: var(--stat-pill-txt);
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
  text-align: center;
  justify-self: end;
}

.statistics-widget .stat-row.is-zero .stat-value {
  background: #f3f4f6;
  color: var(--stat-muted);
}

.statistics-widget .stat-row.is-zero .field-label {
  color: #64748b;
}

/* ==========================================================================
   9) HOUSE POINTS
   ========================================================================== */

.house-points-widget {
  padding: 0;
}

.house-points-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.house-card {
  display: grid;
  grid-template-columns: 30px 42px minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 10px;
  padding: 12px 12px;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff, #fbfdff);
  border: 1px solid rgba(15, 23, 42, 0.07);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition: transform 0.18s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  min-width: 0;
}

.house-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  border-color: rgba(34, 126, 189, 0.14);
}

.house-card--leader {
  background: linear-gradient(180deg, #fffdf7, #fffaf0);
  border-color: rgba(217, 119, 6, 0.18);
  box-shadow: 0 8px 20px rgba(217, 119, 6, 0.08);
}

.house-rank {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #f1f5f9;
  color: var(--text-strong, #0f172a);
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  flex: 0 0 auto;
}

.house-card--leader .house-rank {
  background: linear-gradient(180deg, #fbbf24, #f59e0b);
  color: #fff;
  box-shadow: 0 6px 14px rgba(245, 158, 11, 0.22);
}

.house-logo {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  flex: 0 0 auto;
}

.house-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.house-meta {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.house-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 700;
  color: #0f172a;
}

.house-bar {
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
  background: #edf2f7;
}

.house-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.45s ease;
  background: linear-gradient(90deg, rgba(34, 126, 189, 0.5), rgba(34, 126, 189, 0.95));
}

.house-points {
  white-space: nowrap;
  font-size: 14px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
  padding: 7px 10px;
  border-radius: 999px;
  background: rgba(34, 126, 189, 0.08);
  border: 1px solid rgba(34, 126, 189, 0.1);
}

.house-card--leader .house-points {
  background: rgba(245, 158, 11, 0.12);
  border-color: rgba(245, 158, 11, 0.16);
}

.empty-state {
  padding: 12px 4px 6px;
  text-align: left;
  color: var(--text-muted);
}

/* dark mode */
[data-theme='dark'] .house-card {
  background: linear-gradient(180deg, #1c2128, #181d23);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

[data-theme='dark'] .house-card--leader {
  background: linear-gradient(180deg, #2a2315, #211c12);
  border-color: rgba(245, 158, 11, 0.2);
}

[data-theme='dark'] .house-rank {
  background: rgba(255, 255, 255, 0.08);
  color: #e5e7eb;
}

[data-theme='dark'] .house-logo {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.08);
}

[data-theme='dark'] .house-name,
[data-theme='dark'] .house-points {
  color: #f8fafc;
}

[data-theme='dark'] .house-bar {
  background: rgba(255, 255, 255, 0.12);
}

[data-theme='dark'] .house-bar-fill {
  background: linear-gradient(90deg, rgba(125, 211, 252, 0.45), rgba(125, 211, 252, 0.95));
}

[data-theme='dark'] .house-points {
  background: rgba(125, 211, 252, 0.12);
  border-color: rgba(125, 211, 252, 0.16);
}

/* ==========================================================================
   10) TIP / WHAT'S NEW / GENERIC
   ========================================================================== */

.tip-widget {
  padding: 0;
  min-width: 0;
}

.tip-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
  padding: 16px;
  border: 1px solid rgba(15, 23, 42, 0.07);
  border-radius: var(--radius-md, 8px);
  background: linear-gradient(180deg, #ffffff, #fbfdff);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
  overflow: hidden;
}

.tip-cardGlow {
  position: absolute;
  top: -28px;
  right: -18px;
  width: 120px;
  height: 120px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(34, 126, 189, 0.12) 0%, rgba(34, 126, 189, 0) 72%);
  pointer-events: none;
}

.tip-cardHeader {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.tip-cardEyebrow {
  margin-bottom: 6px;
  font-size: 11px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.tip-title {
  margin: 0;
  font-size: 17px;
  line-height: 1.3;
  font-weight: 800;
  color: var(--text-strong);
}

.tip-content {
  position: relative;
  z-index: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-main);
}

.tip-content p {
  margin: 0 0 12px;
}

.tip-content p:last-child {
  margin-bottom: 0;
}

.tip-content ul,
.tip-content ol {
  margin: 0 0 12px 18px;
  color: var(--text-main);
}

.tip-content li {
  margin-bottom: 6px;
}

.tip-content strong,
.tip-content b {
  color: var(--text-strong);
}

.tip-content a,
.tip-content a:link,
.tip-content a:visited {
  color: var(--brand-link) !important;
  font-weight: 700;
  text-decoration: underline;
}

.tip-cardFooter {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  padding-top: 2px;
}

.tip-widgetEmpty {
  padding: 10px 2px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-muted);
}

.whatsnew,
.whatsnew .wn-grid,
.whatsnew .wn-card {
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  min-width: 0;
}

.whatsnew .wn-img,
.whatsnew .wn-burst {
  max-width: 100%;
  overflow: hidden;
}

.tip-cardEyebrowWrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.tip-cardIcon {
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: rgba(34, 126, 189, 0.1);
  color: var(--brand-link);
  border: 1px solid rgba(34, 126, 189, 0.12);
}

.tip-cardIcon svg {
  width: 15px;
  height: 15px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ==========================================================================
   11) BUTTONS / LIBRARY
   ========================================================================== */

.primary-cta-btn,
.manage-clubs-btn {
  width: auto;
  min-width: 0;
  padding: 0 14px;
  height: 36px;
  border-radius: var(--radius-md, 8px);
  background: var(--brand-link) !important;
  border: 1px solid var(--brand-link) !important;
  color: #fff !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform 0.06s ease, box-shadow 0.2s ease, background-color 0.2s ease, filter 0.2s ease;
  box-shadow: var(--cta-shadow);
}

.primary-cta-btn:hover,
.manage-clubs-btn:hover {
  filter: brightness(0.95);
  box-shadow: var(--cta-shadow-hover);
}

.primary-cta-btn:active,
.manage-clubs-btn:active {
  transform: translateY(1px);
}

.primary-cta-btn:focus,
.manage-clubs-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.25);
}

.widget-library {
  margin-top: 18px;
  padding: 16px 18px;
  border: 1px solid var(--line-soft);
  border-radius: var(--radius-md, 8px);
  background: linear-gradient(180deg, #ffffff, #fbfdff);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
}

.widget-libraryHeader {
  margin-bottom: 12px;
}

.widget-libraryTitle {
  font-size: 16px;
  line-height: 1.2;
  font-weight: 800;
  color: var(--text-strong);
}

.widget-librarySubtitle {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text-muted);
}

.widget-libraryList {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.widget-libraryBtn {
  min-height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid var(--pill-blue-border-strong);
  background: #f8fbff;
  color: var(--brand-link);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.widget-libraryBtn:hover {
  background: #eef6fb;
  border-color: var(--pill-blue-border-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.1);
}

.widget-libraryBtn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}

.widget-libraryBtn:active {
  transform: translateY(0);
}

/* ==========================================================================
   12) DARK MODE
   ========================================================================== */

[data-theme='dark'] .house-card {
  background: #1a1c20;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: none;
}

[data-theme='dark'] .house-logo {
  background: transparent;
}

[data-theme='dark'] .house-bar {
  background: rgba(255, 255, 255, 0.12);
}

[data-theme='dark'] .house-bar-fill {
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.7));
}

.school-card-actionIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
}

.school-card-actionIcon svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.school-card-badge--action {
  gap: 6px;
  border-radius: var(--radius-md, 8px);
}

.primary-cta-btn,
.widget-libraryBtn,
.widget-libraryRestore {
  border-radius: var(--radius-md, 8px) !important;
  letter-spacing: 0 !important;
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.widget-drag-handle {
  pointer-events: none;
  pointer-events: none;
  touch-action: none;
}

/* Design-system alignment overrides */
.dashboard,
.dashboard button,
.dashboard input,
.dashboard select,
.dashboard textarea {
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.dashboard {
  color: var(--text-body, #334155);
}

.widget-header h4,
.widget-libraryTitle,
.school-card-title,
.profile-card-title,
.statistics-widget .stat-value,
.house-card-title {
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', 'Public Sans', system-ui, sans-serif));
  color: var(--text-strong, #0f172a);
  font-weight: var(--weight-bold, 700);
  letter-spacing: var(--tracking-tight, -0.012em);
}

.dashboard-introSubtitle,
.widget-librarySubtitle,
.school-card-label,
.profile-card-label,
.empty-state-text,
.dashboardPagerText {
  color: var(--text-muted, #64748b);
}

.widget {
  background: var(--surface-card, #ffffff);
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.widget:hover {
  border-color: var(--border-default, #cbd5e1);
  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));
}

.widget-header {
  cursor: grab;
  min-height: 56px;
  background: var(--surface-card, #ffffff);
  border-bottom-color: var(--border-subtle, #e2e8f0);
}

.widget-drag-handle,
.widget-remove,
.dashboardPagerBtn {
  border-color: var(--border-default, #cbd5e1);
  background: var(--slate-0, #ffffff);
  color: var(--text-muted, #64748b);
  border-radius: var(--radius-md, 8px);
}

.widget-dragIcon span {
  background: var(--text-subtle, #94a3b8);
}

.widget-header:hover .widget-drag-handle {
  pointer-events: none;
  color: var(--text-body, #334155);
  border-color: var(--blue-300, #6fb1df);
  background: var(--blue-50, #eef6fc);
}

.primary-cta-btn,
.manage-clubs-btn {
  height: var(--control-h-md, 38px);
  padding: 0 var(--space-5, 16px);
  border-radius: var(--radius-md, 8px) !important;
  background: var(--action-primary, #227ebd) !important;
  border-color: var(--action-primary, #227ebd) !important;
  color: var(--text-on-brand, #ffffff) !important;
  font-size: var(--text-md, 14px);
  font-weight: var(--weight-semibold, 600);
  letter-spacing: var(--tracking-normal, 0) !important;
  box-shadow: none;
  gap: var(--space-3, 8px);
}

.primary-cta-btn:hover,
.manage-clubs-btn:hover {
  background: var(--action-primary-hover, #1a6da3) !important;
  border-color: var(--action-primary-hover, #1a6da3) !important;
  filter: none;
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);
}

.primary-cta-btn:focus,
.manage-clubs-btn:focus,
.widget-libraryBtn:focus,
.widget-libraryRestore:focus,
.school-card-badge--action:focus,
.profile-card-badge--action:focus {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.35));
}

.widget-library {
  background: var(--surface-card, #ffffff);
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.widget-libraryBtn,
.widget-libraryRestore,
.school-card-badge,
.profile-card-badge {
  min-height: var(--control-h-sm, 32px);
  border-radius: var(--radius-pill, 999px);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
  letter-spacing: var(--tracking-normal, 0);
}

.widget-libraryBtn,
.widget-libraryRestore,
.school-card-badge--action,
.profile-card-badge--action {
  background: var(--slate-0, #ffffff);
  border: 1px solid var(--border-default, #cbd5e1);
  color: var(--blue-600, #1a6da3) !important;
}

.widget-libraryBtn:hover,
.widget-libraryRestore:hover,
.school-card-badge--action:hover,
.profile-card-badge--action:hover {
  background: var(--blue-50, #eef6fc);
  border-color: var(--blue-300, #6fb1df);
  color: var(--blue-700, #155d8c) !important;
  box-shadow: none;
  transform: none;
}

.school-card-badge:not(.school-card-badge--action),
.profile-card-badge:not(.profile-card-badge--action) {
  background: var(--status-neutral-bg, #f1f5f9);
  border-color: transparent;
  color: var(--status-neutral-fg, #475569);
}

.school-card-badge--subtle,
.profile-card-badge--subtle {
  color: var(--text-muted, #64748b);
}

.statistics-widget .stat-row,
.house-card,
.tournament-card,
.empty-state,
.school-card-widget,
.profile-card-widget {
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
}

.statistics-widget .stat-icon,
.school-card-actionIcon,
.tip-cardIcon {
  color: var(--blue-600, #1a6da3);
}
/* ==========================================================================\`r\`n   13) DESIGN SYSTEM ALIGNMENT OVERRIDES
   Keep this last: it maps dashboard-specific controls back to squad-theme tokens.
   ========================================================================== */

.dashboard-viewport,
.dashboard-viewport button,
.dashboard-viewport input,
.dashboard-viewport select,
.dashboard-viewport textarea {
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
  color: var(--text-body, #334155);
}

.widget-header h4,
.school-card-title,
.profile-card-title,
.widget-libraryTitle,
.house-card-title,
.stat-value,
.tip-cardTitle {
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  color: var(--text-strong, #0f172a);
  font-weight: var(--weight-bold, 700);
  letter-spacing: var(--tracking-normal, 0);
}

.dashboard-introSubtitle,
.widget-librarySubtitle,
.school-card-label,
.profile-card-label,
.empty-list,
.dashboardPagerText {
  color: var(--text-muted, #64748b);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-medium, 500);
}

.widget {
  background: var(--surface-card, #ffffff);
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.widget:hover {
  border-color: var(--border-default, #cbd5e1);
  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));
}

.widget-header {
  background: var(--surface-card, #ffffff);
  border-bottom-color: var(--border-subtle, #e2e8f0);
}

.widget-drag-handle,
.widget-remove,
.dashboardPagerBtn {
  background: var(--surface-card, #ffffff);
  border: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-muted, #64748b);
  border-radius: var(--radius-md, 8px);
  box-shadow: none;
}

.widget-drag-handle:hover,
.dashboardPagerBtn:hover:not(:disabled) {
  background: var(--surface-hover, #f1f5f9);
  border-color: var(--border-default, #cbd5e1);
  color: var(--text-strong, #0f172a);
  box-shadow: none;
}

.widget-dragIcon span {
  background: currentColor;
}

.widget-remove:hover {
  background: var(--red-50, #fdecee);
  border-color: var(--red-100, #f9d4d9);
  color: var(--red-700, #a52836);
  box-shadow: none;
}

.widget-drag-handle:focus,
.widget-remove:focus,
.dashboardPagerBtn:focus,
.primary-cta-btn:focus,
.manage-clubs-btn:focus,
.widget-libraryBtn:focus,
.widget-libraryRestore:focus {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.35));
}

.primary-cta-btn,
.manage-clubs-btn {
  height: var(--control-h-md, 38px);
  padding: 0 var(--space-5, 16px);
  border-radius: var(--radius-md, 8px) !important;
  border: 1px solid var(--action-primary, #227ebd) !important;
  background: var(--action-primary, #227ebd) !important;
  color: var(--text-on-brand, #ffffff) !important;
  font-size: var(--text-md, 14px);
  font-weight: var(--weight-semibold, 600);
  letter-spacing: var(--tracking-normal, 0) !important;
  box-shadow: none;
  gap: var(--space-3, 8px);
}

.primary-cta-btn:hover,
.manage-clubs-btn:hover {
  background: var(--action-primary-hover, #1a6da3) !important;
  border-color: var(--action-primary-hover, #1a6da3) !important;
  filter: none;
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);
}

.widget-library {
  background: var(--surface-card, #ffffff);
  border-color: var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}

.widget-libraryBtn,
.widget-libraryRestore,
.school-card-badge--action,
.profile-card-badge--action {
  min-height: var(--control-h-sm, 32px);
  padding: 0 var(--space-4, 12px);
  border-radius: var(--radius-md, 8px) !important;
  background: var(--surface-card, #ffffff);
  border: 1px solid var(--border-default, #cbd5e1);
  color: var(--text-link, #1a6da3) !important;
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
  letter-spacing: var(--tracking-normal, 0) !important;
  box-shadow: none;
}

.widget-libraryBtn:hover,
.widget-libraryRestore:hover,
.school-card-badge--action:hover,
.profile-card-badge--action:hover {
  background: var(--blue-50, #eef6fc);
  border-color: var(--blue-300, #6fb1df);
  color: var(--blue-700, #155d8c) !important;
  transform: none;
  box-shadow: none;
  text-decoration: none !important;
}

.school-card-badge,
.profile-card-badge,
.metric-pill,
.house-points-badge,
.stat-pill {
  border-radius: var(--radius-pill, 999px);
  background: var(--status-neutral-bg, #f1f5f9);
  border-color: var(--border-subtle, #e2e8f0);
  color: var(--status-neutral-fg, #475569);
  font-size: var(--text-xs, 12px);
  font-weight: var(--weight-semibold, 600);
  letter-spacing: var(--tracking-normal, 0);
}

.school-card-badge:not(.school-card-badge--subtle),
.profile-card-badge:not(.profile-card-badge--subtle) {
  background: var(--blue-50, #eef6fc);
  border-color: var(--blue-100, #d4e8f6);
  color: var(--blue-700, #155d8c);
}

.dashboardEventRow,
.tournament-card,
.stat-card,
.house-card,
.tip-card {
  border-radius: var(--radius-lg, 12px);
  color: var(--text-body, #334155);
}

.dashboardEventTime,
.school-card-eyebrow,
.profile-card-eyebrow,
.metric-label,
.stat-label,
.tip-cardEyebrow {
  color: var(--text-muted, #64748b);
  font-size: var(--text-xs, 12px);
  font-weight: var(--weight-bold, 700);
  letter-spacing: var(--tracking-caps, 0.06em);
}

.dashboardEventName,
.tournament-name,
.house-name,
.school-card-value,
.profile-card-value {
  color: var(--text-strong, #0f172a);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
}

.school-card-actionIcon,
.statistics-widget .stat-icon,
.tip-cardIcon {
  color: var(--text-link, #1a6da3);
}

.dashboard-widget-list--sortable .dashboard-item--chosen .widget {
  border-color: var(--border-brand, #227ebd);
  box-shadow: var(--shadow-lg, 0 12px 28px rgba(15, 23, 42, 0.12));
}

.dashboard-widget-list--sortable .dashboard-item--ghost {
  opacity: 0.45;
}

.dashboard-widget-list--sortable .dashboard-item--dragging {
  opacity: 0.96;
  break-inside: avoid;
}

.sortable-fallback.dashboard-item {
  width: 304px !important;
  list-style: none;
}

@media (min-width: 1500px) {
  .sortable-fallback.dashboard-item {
    width: 320px !important;
  }
}

.dashboard-widget-list--native .dashboard-item {
  cursor: default;
}

.dashboard-widget-list--native .dashboard-item--dragging {
  opacity: 0.42;
}

.dashboard-widget-list--native .widget-headerMain {
  cursor: grab;
}

.dashboard-widget-list--dragging .widget-headerMain {
  cursor: grabbing;
}

/* Dashboard polish: action controls, important cards, schedule rows */
.dashboard-actionBtn,
.dashboard-actionBtn:link,
.dashboard-actionBtn:visited {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: var(--control-h-sm, 32px);
  padding: 0 var(--space-4, 12px);
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--border-default, #cbd5e1);
  background: var(--surface-card, #ffffff);
  color: var(--text-link, #1a6da3) !important;
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
  line-height: 1;
  letter-spacing: var(--tracking-normal, 0);
  text-decoration: none !important;
  box-shadow: none;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.dashboard-actionBtn:hover,
.dashboard-actionBtn:focus {
  background: var(--blue-50, #eef6fc);
  border-color: var(--blue-300, #6fb1df);
  color: var(--blue-700, #155d8c) !important;
  text-decoration: none !important;
}

.dashboard-iconBtn,
.dashboard-iconBtn:link,
.dashboard-iconBtn:visited {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--control-h-sm, 32px);
  height: var(--control-h-sm, 32px);
  padding: 0;
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--border-default, #cbd5e1);
  background: var(--surface-card, #ffffff);
  color: var(--text-link, #1a6da3) !important;
  text-decoration: none !important;
  box-shadow: none;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.dashboard-iconBtn:hover,
.dashboard-iconBtn:focus {
  background: var(--blue-50, #eef6fc);
  border-color: var(--blue-300, #6fb1df);
  color: var(--blue-700, #155d8c) !important;
}

.dashboard-actionBtn:focus,
.dashboard-iconBtn:focus {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.35));
}

.school-card-actions,
.profile-card-actions {
  align-items: center;
  gap: var(--space-3, 8px);
}

.profile-card-badge {
  text-transform: none;
}

.school-card-actionIcon,
.school-card-actionIcon svg {
  width: 16px;
  height: 16px;
}

.widget .important-event-card,
.widget .important-event-card:link,
.widget .important-event-card:visited {
  grid-template-columns: 38px minmax(0, 1fr) auto;
  gap: var(--space-3, 8px);
  padding: var(--space-3, 8px) var(--space-4, 12px);
  border-radius: var(--radius-lg, 12px);
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #ffffff);
  box-shadow: none;
}

.widget .important-event-card:hover {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-hover, #f8fafc);
  box-shadow: none;
  transform: none;
}

.important-event-cardIcon {
  width: 38px;
  height: 38px;
  display: inline-grid;
  place-items: center;
  border-radius: var(--radius-md, 8px);
  border: 1px solid transparent;
}

.important-event-cardIcon svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.important-event-card--requests .important-event-cardIcon {
  background: var(--blue-50, #eef6fc);
  border-color: var(--blue-100, #d4e8f6);
  color: var(--blue-700, #155d8c);
}

.important-event-card--invites .important-event-cardIcon {
  background: var(--green-50, #ecfdf3);
  border-color: var(--green-100, #d1fadf);
  color: var(--green-700, #047857);
}

.important-event-card--tournaments .important-event-cardIcon {
  background: var(--amber-50, #fffbeb);
  border-color: var(--amber-100, #fef3c7);
  color: var(--amber-700, #b45309);
}

.important-event-cardCount {
  min-width: 28px;
  height: 24px;
  padding: 0 8px;
  border-radius: var(--radius-pill, 999px);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
  font-size: var(--text-xs, 12px);
  font-weight: var(--weight-bold, 700);
  box-shadow: none;
}

.important-event-cardTitle {
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
}

.important-event-cardMeta {
  color: var(--text-muted, #64748b);
  font-size: var(--text-xs, 12px);
}

.dashboardScheduleRow,
.dashboardScheduleRow:link,
.dashboardScheduleRow:visited {
  display: grid !important;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: var(--space-3, 8px);
  align-items: center;
  width: 100%;
  min-width: 0;
  padding: 9px 0;
  color: var(--text-body, #334155) !important;
  text-decoration: none !important;
}

.dashboardScheduleRow:hover {
  text-decoration: none !important;
}

.dashboardScheduleBlock {
  min-width: 0;
  min-height: 48px;
  padding: 7px 8px;
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--blue-100, #d4e8f6);
  background: var(--blue-50, #eef6fc);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dashboardScheduleEyebrow {
  font-size: 10px;
  line-height: 1.1;
  font-weight: var(--weight-bold, 700);
  letter-spacing: var(--tracking-caps, 0.06em);
  text-transform: uppercase;
  color: var(--text-muted, #64748b);
}

.dashboardScheduleDate {
  margin-top: 2px;
  font-size: var(--text-sm, 13px);
  line-height: 1.1;
  font-weight: var(--weight-bold, 700);
  color: var(--blue-700, #155d8c);
}

.dashboardScheduleTime {
  margin-top: 2px;
  font-size: var(--text-xs, 12px);
  line-height: 1.1;
  font-weight: var(--weight-bold, 700);
  color: var(--text-strong, #0f172a);
  font-variant-numeric: tabular-nums;
}

.dashboardScheduleMain {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.dashboardScheduleName {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--text-strong, #0f172a);
  font-size: var(--text-sm, 13px);
  font-weight: var(--weight-semibold, 600);
  line-height: 1.25;
}

.dashboardScheduleMeta {
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: var(--text-xs, 12px);
  line-height: 1.3;
}

.tip-cta-btn {
  text-transform: none !important;
}
.dashboard-setupBanner {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: center;
  margin-bottom: 18px;
  border: 1px solid #b9d8ec;
  border-radius: 12px;
  background: #eef7fc;
  padding: 16px 18px;
}

.dashboard-setupBanner strong,
.dashboard-setupBanner span {
  display: block;
}

.dashboard-setupBanner strong {
  color: #153e63;
}

.dashboard-setupBanner span {
  margin-top: 4px;
  color: #567188;
  font-size: 13px;
}

.dashboard-setupBanner a {
  flex: 0 0 auto;
  border-radius: 8px;
  background: #17699c;
  color: #fff;
  padding: 9px 14px;
  font-weight: 700;
  text-decoration: none;
}

@media (max-width: 640px) {
  .dashboard-setupBanner {
    align-items: stretch;
    flex-direction: column;
  }

  .dashboard-setupBanner a {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;;EAEvC,oBAAoB;EACpB,8CAA8C;EAC9C,sDAAsD;EACtD,mEAAmE;EACnE,0EAA0E;;EAE1E,gDAAgD;EAChD,sCAAsC;EACtC,8CAA8C;;EAE9C,0CAA0C;EAC1C,0CAA0C;;EAE1C,uCAAuC;EACvC,4CAA4C;EAC5C,yDAAyD;EACzD,kDAAkD;;EAElD,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,mCAAmC;AACrC;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;+EAE+E;;AAE/E;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,oCAAoC;EACpC,kDAAkD;EAClD,6EAA6E;EAC7E,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;EACxC,qCAAqC;EACrC,YAAY;EACZ,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,oCAAoC;EACpC,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAGE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;;EAGE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;;+EAE+E;;AAE/E;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;;;;EAIE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qDAAqD;EACrD,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,iCAAiC;EACjC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gDAAgD;EAChD,gCAAgC;EAChC,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qDAAqD;EACrD,iCAAiC;EACjC,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;EACxB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gDAAgD;EAChD,gCAAgC;EAChC,gFAAgF;AAClF;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,qDAAqD;EACrD,oCAAoC;EACpC,gCAAgC;EAChC,4CAA4C;EAC5C,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,oDAAoD;EACpD,iCAAiC;EACjC,qBAAqB;EACrB,uCAAuC;EACvC,wBAAwB;;EAExB,UAAU;EACV,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,8EAA8E;AAChF;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2DAA2D;EAC3D,gCAAgC;EAChC,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,wCAAwC;EACxC,4CAA4C;EAC5C,8EAA8E;EAC9E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,qFAAqF;AACvF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,cAAc;AACd;EACE,qDAAqD;EACrD,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;+EAE+E;;AAE/E;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,oCAAoC;EACpC,qDAAqD;EACrD,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;;EAGE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;+EAE+E;;AAE/E;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,oCAAoC;EACpC,wCAAwC;EACxC,8CAA8C;EAC9C,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,oGAAoG;EACpG,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;EACpC,qDAAqD;EACrD,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gDAAgD;EAChD,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uGAAuG;AACzG;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E;EACE,mBAAmB;EACnB,WAAW;EACX,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,oCAAoC;AACtC;;AAEA;;;EAGE,+CAA+C;EAC/C,4BAA4B;EAC5B,8FAA8F;AAChG;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;;;;;EAKE,8FAA8F;AAChG;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;EAME,6GAA6G;EAC7G,kCAAkC;EAClC,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,4CAA4C;EAC5C,+DAA+D;AACjE;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;;;EAGE,4CAA4C;EAC5C,mCAAmC;EACnC,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;;EAEE,iCAAiC;EACjC,+BAA+B;EAC/B,+CAA+C;EAC/C,qDAAqD;EACrD,uDAAuD;EACvD,+CAA+C;EAC/C,+BAA+B;EAC/B,wCAAwC;EACxC,oDAAoD;EACpD,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,2DAA2D;EAC3D,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;;;;;;EAME,aAAa;EACb,mEAAmE;AACrE;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;;;;EAIE,qCAAqC;EACrC,wCAAwC;EACxC,+BAA+B;EAC/B,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;;;;EAIE,mCAAmC;EACnC,gDAAgD;EAChD,0CAA0C;AAC5C;;AAEA;;;;EAIE,mCAAmC;EACnC,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,6CAA6C;EAC7C,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;;;;;EAME,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;;;EAGE,+BAA+B;AACjC;AACA;;+EAE+E;;AAE/E;;;;;EAKE,8FAA8F;EAC9F,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,8FAA8F;EAC9F,kCAAkC;EAClC,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;;;;;;EAME,iCAAiC;EACjC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,4CAA4C;EAC5C,+DAA+D;AACjE;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;;;EAGE,wCAAwC;EACxC,+CAA+C;EAC/C,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;EACzC,4CAA4C;EAC5C,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;;;;;;EAOE,aAAa;EACb,mEAAmE;AACrE;;AAEA;;EAEE,iCAAiC;EACjC,+BAA+B;EAC/B,+CAA+C;EAC/C,2DAA2D;EAC3D,qDAAqD;EACrD,+CAA+C;EAC/C,+BAA+B;EAC/B,wCAAwC;EACxC,oDAAoD;EACpD,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,2DAA2D;EAC3D,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;;;;EAIE,qCAAqC;EACrC,+BAA+B;EAC/B,+CAA+C;EAC/C,wCAAwC;EACxC,gDAAgD;EAChD,2CAA2C;EAC3C,+BAA+B;EAC/B,wCAAwC;EACxC,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;;;;EAIE,mCAAmC;EACnC,sCAAsC;EACtC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;;;;EAKE,wCAAwC;EACxC,6CAA6C;EAC7C,2CAA2C;EAC3C,wCAAwC;EACxC,+BAA+B;EAC/B,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;;EAEE,mCAAmC;EACnC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;;;;;EAKE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;;;;;EAME,iCAAiC;EACjC,+BAA+B;EAC/B,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;;;;;EAKE,kCAAkC;EAClC,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,gEAAgE;AAClE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,+BAA+B;EAC/B,oCAAoC;EACpC,gDAAgD;EAChD,wCAAwC;EACxC,2CAA2C;EAC3C,8FAA8F;EAC9F,+BAA+B;EAC/B,wCAAwC;EACxC,cAAc;EACd,yCAAyC;EACzC,gCAAgC;EAChC,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;;EAEE,mCAAmC;EACnC,sCAAsC;EACtC,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,iCAAiC;EACjC,UAAU;EACV,oCAAoC;EACpC,gDAAgD;EAChD,wCAAwC;EACxC,2CAA2C;EAC3C,gCAAgC;EAChC,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;;EAEE,mCAAmC;EACnC,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;;EAEE,aAAa;EACb,mEAAmE;AACrE;;AAEA;;EAEE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE,+CAA+C;EAC/C,wBAAwB;EACxB,iDAAiD;EACjD,qCAAqC;EACrC,2CAA2C;EAC3C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,0CAA0C;EAC1C,kCAAkC;EAClC,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;;;EAGE,wBAAwB;EACxB,0CAA0C;EAC1C,wBAAwB;EACxB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,4CAA4C;EAC5C,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;EAC/B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[":root {\n  --brand-link: var(--text-link, #1a6da3);\n\n  --widget-bg: #ffffff;\n  --widget-border: var(--border-subtle, #e2e8f0);\n  --widget-border-strong: var(--border-default, #cbd5e1);\n  --widget-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n  --widget-shadow-hover: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));\n\n  --text-strong-local: var(--text-strong, #0f172a);\n  --text-main: var(--text-body, #334155);\n  --text-muted-local: var(--text-muted, #64748b);\n\n  --line-soft: var(--border-subtle, #e2e8f0);\n  --line-mid: var(--border-default, #cbd5e1);\n\n  --pill-blue-bg: var(--blue-50, #eef6fc);\n  --pill-blue-border: var(--blue-100, #d4e8f6);\n  --pill-blue-border-strong: var(--border-default, #cbd5e1);\n  --pill-blue-border-hover: var(--blue-300, #6fb1df);\n\n  --cta-shadow: none;\n  --cta-shadow-hover: 0 4px 12px rgba(34, 126, 189, 0.28);\n}\n\n/* ==========================================================================\n   1) DASHBOARD LAYOUT\n   ========================================================================== */\n\n.dashboard-viewport {\n  width: 100%;\n  margin-top: 0 !important;\n  padding: 0 0 28px;\n  box-sizing: border-box;\n  background: var(--surface-page, #f8fafc);\n}\n\n.dashboard {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n}\n\n.dashboard-intro {\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 86px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin: -20px 0 18px -24px;\n  padding: 14px 72px 14px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.dashboard-introTitle {\n  font-family: var(--font-heading, var(--font-display, inherit));\n  font-size: 22px;\n  line-height: 1.1;\n  font-weight: 800;\n  color: var(--text-strong);\n  letter-spacing: -0.015em;\n}\n\n.dashboard-introSubtitle {\n  margin-top: 5px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--text-muted);\n}\n\n.dashboard-setupLink {\n  flex: 0 0 auto;\n  border: 1px solid #b8c9d8;\n  border-radius: 8px;\n  background: #fff;\n  padding: 9px 13px;\n  color: #195f8d;\n  font-size: 13px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.dashboard-setupLink:hover,\n.dashboard-setupLink:focus {\n  border-color: #3687b7;\n  background: #eef7fc;\n  color: #174f77;\n  text-decoration: none;\n}\n\n@media (max-width: 1217px) {\n  .dashboard-intro {\n    width: 100vw;\n    margin-top: -16px;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n\n@media (max-width: 640px) {\n  .dashboard-intro {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .dashboard-setupLink {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n.dashboard-widget-list {\n  display: block;\n  width: 100%;\n  column-width: 304px;\n  column-gap: var(--space-5, 16px);\n}\n\n.dashboard-widget-list--muuri {\n  position: relative;\n  display: block;\n  column-width: auto;\n  column-gap: 0;\n  min-height: 360px;\n  transition: height var(--dur-base, 0.18s) var(--ease-out, ease);\n}\n\n.dashboard-item {\n  min-width: 0;\n  box-sizing: border-box;\n  display: inline-block;\n  width: 100%;\n  margin: 0 0 var(--space-5, 16px);\n  break-inside: avoid;\n}\n\n.dashboard-widget-list--muuri .dashboard-item {\n  position: absolute;\n  display: block;\n  width: 304px;\n  margin: 0 16px 16px 0;\n  z-index: 1;\n  break-inside: auto;\n}\n\n.dashboard-widget-list--muuri .dashboard-item.muuri-item-dragging {\n  z-index: 4;\n}\n\n.dashboard-widget-list--muuri .dashboard-item.muuri-item-releasing {\n  z-index: 3;\n}\n\n.dashboard-widget-list--muuri .dashboard-item.muuri-item-hidden {\n  z-index: 0;\n}\n\n.dashboard-item > div {\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-widget-list--muuri .dashboard-item.muuri-item-dragging .widget {\n  box-shadow: var(--shadow-lg, 0 12px 28px rgba(15, 23, 42, 0.12));\n  border-color: var(--border-brand, #227ebd);\n  transform: none;\n}\n\n.dashboard-widget-list--muuri .dashboard-item .muuri-item-placeholder {\n  border-radius: var(--radius-md, 8px);\n  border: 1px dashed var(--border-brand, #227ebd);\n  background: var(--blue-50, #eef6fc);\n}\n\n@media (min-width: 1500px) {\n  .dashboard-widget-list {\n    column-width: 320px;\n  }\n\n  .dashboard-widget-list--muuri .dashboard-item {\n    width: 320px;\n  }\n}\n\n@media (max-width: 760px) {\n  .dashboard-viewport {\n    padding: 0 0 24px;\n  }\n\n  .dashboard-intro {\n    width: 100vw;\n    min-height: 76px;\n    align-items: flex-start;\n    flex-direction: column;\n    justify-content: center;\n    margin: -16px 0 14px -16px;\n    padding: 12px 16px;\n  }\n\n  .dashboard-introTitle {\n    font-size: 20px;\n  }\n\n  .dashboard-widget-list {\n    column-width: auto;\n  }\n\n  .dashboard-widget-list--muuri .dashboard-item {\n    width: 100%;\n    margin-right: 0;\n  }\n}\n\n.dashboardPager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-top: 10px;\n}\n\n.dashboardPagerBtn {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--line-mid);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-main);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n\n.dashboardPagerBtn:hover:not(:disabled) {\n  background: rgba(34, 126, 189, 0.06);\n  border-color: rgba(34, 126, 189, 0.18);\n  color: var(--brand-link);\n}\n\n.dashboardPagerBtn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.dashboardPagerText {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-muted);\n  min-width: 42px;\n  text-align: center;\n}\n\n/* ==========================================================================\n   2) WIDGET SHELL\n   ========================================================================== */\n\n.widget {\n  background: var(--widget-bg);\n  border: 1px solid var(--widget-border);\n  border-radius: var(--radius-md, 8px);\n  box-shadow: var(--shadow-sm, var(--widget-shadow));\n  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n}\n\n.widget-header {\n  user-select: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--line-soft);\n  background: #ffffff;\n}\n\n.widget-header::before {\n  display: none !important;\n}\n\n.widget-headerMain {\n  cursor: grab;\n  touch-action: none;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.dashboard-widget-list--dragging .widget-headerMain {\n  cursor: grabbing;\n}\n\n.widget-titleWrap {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.widget-header h4 {\n  margin: 0;\n  min-width: 0;\n  font-size: 15px;\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--text-strong, #0f172a);\n}\n\n.widget-drag-handle {\n  pointer-events: none;\n  pointer-events: none;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  background: rgba(255, 255, 255, 0.72);\n  cursor: grab;\n  transition: background 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.widget-drag-handle:hover {\n  background: #fff;\n  border-color: rgba(34, 126, 189, 0.14);\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);\n}\n\n.dashboard-widget-list--muuri .dashboard-item.muuri-item-dragging .widget-header {\n  cursor: grabbing;\n}\n\n.widget-drag-handle:active {\n  cursor: grabbing;\n}\n\n.widget-dragIcon {\n  width: 12px;\n  height: 12px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2px;\n}\n\n.widget-dragIcon span {\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: #94a3b8;\n  display: block;\n}\n\n.widget-remove {\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  border: 1px solid var(--line-mid);\n  border-radius: var(--radius-md, 8px);\n  background: rgba(15, 23, 42, 0.03);\n  color: #64748b;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.widget-remove:hover {\n  background: rgba(239, 68, 68, 0.08);\n  color: #b91c1c;\n  border-color: rgba(239, 68, 68, 0.16);\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.08);\n}\n\n.widget-drag-handle:focus,\n.widget-remove:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);\n}\n\n.widget:hover {\n  box-shadow: var(--widget-shadow-hover);\n  border-color: var(--widget-border-strong);\n  transform: translateY(-1px);\n}\n\n.widget-header::before {\n  display: none !important;\n}\n\n.widget-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  padding: 14px 16px 16px;\n  overflow-x: hidden;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.widget .widget-content a,\n.widget .widget-content a:link,\n.widget .widget-content a:visited {\n  color: var(--brand-link) !important;\n  text-decoration: none;\n}\n\n.widget .widget-content a:hover,\n.widget .widget-content a:focus,\n.widget .widget-content a:active {\n  color: var(--brand-link) !important;\n  text-decoration: underline;\n}\n\n/* ==========================================================================\n   3) COMMON EVENT / FIXTURE / TOURNAMENT LISTS\n   ========================================================================== */\n\n.fixtures-widget,\n.week-fixtures-widget,\n.clubs-widget,\n.upcoming-tournaments-widget {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n}\n\n.fixtures-list-area,\n.week-fixtures-list-area,\n.clubs-list-area,\n.upcoming-tournaments-list-area {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.fixtures-footer,\n.week-fixtures-footer,\n.clubs-footer,\n.upcoming-tournaments-footer {\n  margin-top: auto;\n  padding-top: 10px;\n  border-top: 1px solid var(--line-soft);\n  display: flex;\n  justify-content: flex-end;\n}\n\n.dashboardEventList,\n.tournaments-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  min-width: 0;\n}\n\n.dashboardEventList li,\n.tournaments-list li {\n  border-bottom: 1px solid var(--line-soft);\n}\n\n.dashboardEventList li:last-child,\n.tournaments-list li:last-child {\n  border-bottom: none;\n}\n\n/* today fixtures / clubs */\n.dashboardEventRow {\n  display: grid;\n  grid-template-columns: 64px minmax(0, 1fr);\n  gap: 10px;\n  align-items: center;\n  min-width: 0;\n  padding: 10px 0;\n  text-decoration: none;\n}\n\n.dashboardEventRow:hover {\n  background: rgba(34, 126, 189, 0.05);\n  border-radius: var(--radius-md, 8px);\n}\n\n.dashboardEventTime {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--brand-link);\n  white-space: nowrap;\n}\n\n.dashboardEventName {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-strong);\n  line-height: 1.25;\n}\n\n/* upcoming tournaments */\n.upcoming-tournament-row {\n  display: grid !important;\n  grid-template-columns: 84px minmax(0, 1fr);\n  gap: 10px;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  padding: 10px 0;\n}\n\n.upcoming-tournament-dateBlock {\n  min-width: 0;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #f8fbff, #eef6fb);\n  border: 1px solid rgba(34, 126, 189, 0.12);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.upcoming-tournament-date {\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.15;\n  color: var(--brand-link);\n}\n\n.upcoming-tournament-time {\n  margin-top: 2px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-main);\n}\n\n.upcoming-tournament-main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.upcoming-tournament-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--text-strong);\n}\n\n.upcoming-tournament-meta {\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--text-muted);\n  line-height: 1.3;\n}\n\n/* ==========================================================================\n   4) EMPTY STATE\n   ========================================================================== */\n\n.widget-empty-state {\n  padding: 12px 2px 6px;\n}\n\n.widget-empty-stateTitle {\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--text-main);\n}\n\n.widget-empty-stateText {\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-muted);\n}\n\n/* ==========================================================================\n   5) SCHOOL DETAILS CARD\n   ========================================================================== */\n\n.school-card-widget {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.school-card-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.school-logo-wrapper,\n.school-logo-wrapper--large {\n  width: 92px;\n  height: 92px;\n  overflow: hidden;\n  border-radius: 20px;\n  background: linear-gradient(180deg, #ffffff, #f5f8fb);\n  border: 1px solid var(--line-mid);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);\n  flex: 0 0 auto;\n}\n\n.school-logo-wrapper img,\n.school-logo-wrapper--large img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.school-card-main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.school-card-eyebrow {\n  font-size: 11px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n}\n\n.school-card-title {\n  margin: 0 0 10px;\n  font-size: 18px;\n  line-height: 1.15;\n  font-weight: 800;\n  color: var(--text-strong);\n}\n\n.school-card-title a {\n  color: inherit !important;\n  text-decoration: none !important;\n}\n\n.school-card-title a:hover {\n  text-decoration: underline !important;\n}\n\n.school-card-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.school-card-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--pill-blue-bg);\n  color: var(--brand-link);\n  border: 1px solid var(--pill-blue-border);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.school-card-badge--subtle {\n  background: #f8fafc;\n  color: var(--text-main);\n  border-color: var(--line-mid);\n}\n\n.school-card-badge--action {\n  background: #f8fbff;\n  color: var(--brand-link) !important;\n  border: 1px solid var(--pill-blue-border-strong);\n  text-decoration: none !important;\n  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;\n}\n\n.school-card-badge--action:hover {\n  background: #eef6fb;\n  border-color: var(--pill-blue-border-hover);\n  text-decoration: none !important;\n  transform: translateY(-1px);\n}\n\n.school-card-body {\n  border-top: 1px solid var(--line-soft);\n  padding-top: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.school-card-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.school-card-label {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.school-card-value {\n  color: var(--text-main);\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n.school-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* ==========================================================================\n   6) PROFILE CARD\n   ========================================================================== */\n\n.profile-card-widget {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.profile-card-top {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.profile-avatar,\n.profile-avatar--large {\n  width: 92px;\n  height: 92px;\n  overflow: hidden;\n  border-radius: 50%;\n  flex: 0 0 auto;\n  background: linear-gradient(180deg, #ffffff, #f5f8fb);\n  border: 1px solid var(--line-mid);\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);\n}\n\n.profile-avatar img,\n.profile-avatar--large img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.profile-card-main {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.profile-card-eyebrow {\n  font-size: 11px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 6px;\n}\n\n.profile-card-title {\n  margin: 0 0 10px;\n  font-size: 18px;\n  line-height: 1.15;\n  font-weight: 800;\n  color: var(--text-strong);\n}\n\n.profile-card-title a {\n  color: inherit !important;\n  text-decoration: none !important;\n}\n\n.profile-card-title a:hover {\n  text-decoration: underline !important;\n}\n\n.profile-card-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.profile-card-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--pill-blue-bg);\n  color: var(--brand-link);\n  border: 1px solid var(--pill-blue-border);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.profile-card-badge--subtle {\n  background: #f8fafc;\n  color: var(--text-main);\n  border-color: var(--line-mid);\n}\n\n.profile-card-badge--action {\n  background: #f8fbff;\n  color: var(--brand-link) !important;\n  border: 1px solid var(--pill-blue-border-strong);\n  text-decoration: none !important;\n  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;\n}\n\n.profile-card-badge--action:hover {\n  background: #eef6fb;\n  border-color: var(--pill-blue-border-hover);\n  text-decoration: none !important;\n  transform: translateY(-1px);\n}\n\n.profile-card-body {\n  border-top: 1px solid var(--line-soft);\n  padding-top: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.profile-card-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.profile-card-label {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.profile-card-value {\n  color: var(--text-main);\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n.profile-card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* ==========================================================================\n   7) IMPORTANT WIDGET\n   ========================================================================== */\n\n.important-events-widget {\n  display: grid;\n  gap: 10px;\n  padding: 2px 0;\n}\n\n.important-events-list {\n  display: grid;\n  gap: 10px;\n}\n\n.widget .important-event-card,\n.widget .important-event-card:link,\n.widget .important-event-card:visited {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid var(--line-mid);\n  background: linear-gradient(180deg, #ffffff, #fbfdff);\n  color: var(--text-strong) !important;\n  text-decoration: none !important;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.widget .important-event-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);\n  border-color: rgba(34, 126, 189, 0.18);\n  text-decoration: none !important;\n}\n\n.important-event-cardCount {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border-radius: 999px;\n  display: inline-grid;\n  place-items: center;\n  background: #f97316;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 800;\n  box-shadow: 0 4px 10px rgba(249, 115, 22, 0.25);\n}\n\n.important-event-cardBody {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.important-event-cardTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-strong);\n  line-height: 1.2;\n}\n\n.important-event-cardMeta {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.important-event-cardArrow {\n  color: var(--text-muted);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* ==========================================================================\n   8) STATISTICS\n   ========================================================================== */\n\n.statistics-widget {\n  --stat-bg: linear-gradient(180deg, #ffffff, #f8fbff);\n  --stat-bd: rgba(15, 23, 42, 0.06);\n  --stat-muted: #94a3b8;\n  --stat-pill-bg: rgba(34, 126, 189, 0.1);\n  --stat-pill-txt: #1f5f91;\n\n  padding: 0;\n  border: 1px solid var(--stat-bd);\n  border-radius: 14px;\n  background: var(--stat-bg);\n}\n\n.statistics-widget .statistics-list {\n  display: grid;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.eventCommunications-widget .statistics-list {\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n}\n.eventCommunications-widget {\n  display: flex;\n  min-height: 0;\n  flex-direction: column;\n  gap: 14px;\n}\n.statistics-widget.eventCommunications-widget .stat-row {\n  min-width: 0;\n  grid-template-columns: minmax(0, 1fr) auto;\n  padding: 10px 12px;\n}\n.eventCommunications-widget .stat-main {\n  min-width: 0;\n}\n.statistics-widget.eventCommunications-widget .field-label {\n  min-width: 0;\n  font-size: 12px;\n  line-height: 1.3;\n  overflow-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n}\n.eventCommunications-widget .stat-value {\n  min-width: 36px;\n  flex: 0 0 auto;\n}\n.eventCommunications-widget > .primary-cta-btn {\n  position: static;\n  z-index: auto;\n  width: 100%;\n  min-height: 38px;\n  flex: 0 0 auto;\n  margin: 0;\n}\n.eventCommunications-widget--unavailable {\n  justify-content: center;\n  min-height: 150px;\n  text-align: center;\n}\n.eventCommunications-widget--unavailable p {\n  margin: 0;\n  color: #69768c;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.eventCommunications-widget .statistics-list > li {\n  list-style: none;\n}\n.eventCommunications-widget .stat-row {\n  width: 100%;\n  color: inherit;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n}\n.eventCommunications-widget .stat-row.is-muted {\n  color: #94a3b8;\n  background: #fafbfc;\n}\n.eventCommunications-widget .stat-row.is-pending .stat-value {\n  color: #a85c07;\n  background: #ffe9c2;\n}\n.eventCommunications-widget .stat-row.is-reported .stat-value {\n  color: #a52836;\n  background: #f9d4d9;\n}\n.eventCommunications-widget__group {\n  padding: 4px 3px 0;\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.statistics-widget .stat-row {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--stat-bd);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.statistics-widget .stat-row:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n  border-color: rgba(34, 126, 189, 0.14);\n}\n\n.statistics-widget .stat-icon {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--brand-link) 10%, #fff);\n  border: 1px solid var(--stat-bd);\n  color: var(--brand-link);\n  flex: 0 0 32px;\n}\n\n.statistics-widget .stat-icon svg {\n  width: 18px;\n  height: 18px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.statistics-widget .stat-row.is-zero .stat-icon {\n  color: var(--text-muted);\n  background: #f8fafc;\n}\n\n.statistics-widget .stat-main {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n}\n\n.statistics-widget .field-label {\n  margin: 0;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.35;\n  font-weight: 700;\n  color: var(--text-strong);\n  word-break: break-word;\n}\n\n.statistics-widget .stat-value {\n  min-width: 40px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: var(--stat-pill-bg);\n  color: var(--stat-pill-txt);\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 1;\n  text-align: center;\n  justify-self: end;\n}\n\n.statistics-widget .stat-row.is-zero .stat-value {\n  background: #f3f4f6;\n  color: var(--stat-muted);\n}\n\n.statistics-widget .stat-row.is-zero .field-label {\n  color: #64748b;\n}\n\n/* ==========================================================================\n   9) HOUSE POINTS\n   ========================================================================== */\n\n.house-points-widget {\n  padding: 0;\n}\n\n.house-points-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 10px;\n}\n\n.house-card {\n  display: grid;\n  grid-template-columns: 30px 42px minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 10px;\n  padding: 12px 12px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #ffffff, #fbfdff);\n  border: 1px solid rgba(15, 23, 42, 0.07);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n  transition: transform 0.18s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  min-width: 0;\n}\n\n.house-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n  border-color: rgba(34, 126, 189, 0.14);\n}\n\n.house-card--leader {\n  background: linear-gradient(180deg, #fffdf7, #fffaf0);\n  border-color: rgba(217, 119, 6, 0.18);\n  box-shadow: 0 8px 20px rgba(217, 119, 6, 0.08);\n}\n\n.house-rank {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: var(--text-strong, #0f172a);\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1;\n  flex: 0 0 auto;\n}\n\n.house-card--leader .house-rank {\n  background: linear-gradient(180deg, #fbbf24, #f59e0b);\n  color: #fff;\n  box-shadow: 0 6px 14px rgba(245, 158, 11, 0.22);\n}\n\n.house-logo {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  flex: 0 0 auto;\n}\n\n.house-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.house-meta {\n  min-width: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.house-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.house-bar {\n  height: 8px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: #edf2f7;\n}\n\n.house-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  transition: width 0.45s ease;\n  background: linear-gradient(90deg, rgba(34, 126, 189, 0.5), rgba(34, 126, 189, 0.95));\n}\n\n.house-points {\n  white-space: nowrap;\n  font-size: 14px;\n  line-height: 1;\n  font-weight: 800;\n  color: #0f172a;\n  padding: 7px 10px;\n  border-radius: 999px;\n  background: rgba(34, 126, 189, 0.08);\n  border: 1px solid rgba(34, 126, 189, 0.1);\n}\n\n.house-card--leader .house-points {\n  background: rgba(245, 158, 11, 0.12);\n  border-color: rgba(245, 158, 11, 0.16);\n}\n\n.empty-state {\n  padding: 12px 4px 6px;\n  text-align: left;\n  color: var(--text-muted);\n}\n\n/* dark mode */\n[data-theme='dark'] .house-card {\n  background: linear-gradient(180deg, #1c2128, #181d23);\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: none;\n}\n\n[data-theme='dark'] .house-card--leader {\n  background: linear-gradient(180deg, #2a2315, #211c12);\n  border-color: rgba(245, 158, 11, 0.2);\n}\n\n[data-theme='dark'] .house-rank {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e5e7eb;\n}\n\n[data-theme='dark'] .house-logo {\n  background: transparent;\n  border-color: rgba(255, 255, 255, 0.08);\n}\n\n[data-theme='dark'] .house-name,\n[data-theme='dark'] .house-points {\n  color: #f8fafc;\n}\n\n[data-theme='dark'] .house-bar {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n[data-theme='dark'] .house-bar-fill {\n  background: linear-gradient(90deg, rgba(125, 211, 252, 0.45), rgba(125, 211, 252, 0.95));\n}\n\n[data-theme='dark'] .house-points {\n  background: rgba(125, 211, 252, 0.12);\n  border-color: rgba(125, 211, 252, 0.16);\n}\n\n/* ==========================================================================\n   10) TIP / WHAT'S NEW / GENERIC\n   ========================================================================== */\n\n.tip-widget {\n  padding: 0;\n  min-width: 0;\n}\n\n.tip-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid rgba(15, 23, 42, 0.07);\n  border-radius: var(--radius-md, 8px);\n  background: linear-gradient(180deg, #ffffff, #fbfdff);\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);\n  overflow: hidden;\n}\n\n.tip-cardGlow {\n  position: absolute;\n  top: -28px;\n  right: -18px;\n  width: 120px;\n  height: 120px;\n  border-radius: 999px;\n  background: radial-gradient(circle, rgba(34, 126, 189, 0.12) 0%, rgba(34, 126, 189, 0) 72%);\n  pointer-events: none;\n}\n\n.tip-cardHeader {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n}\n\n.tip-cardEyebrow {\n  margin-bottom: 6px;\n  font-size: 11px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.tip-title {\n  margin: 0;\n  font-size: 17px;\n  line-height: 1.3;\n  font-weight: 800;\n  color: var(--text-strong);\n}\n\n.tip-content {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.65;\n  color: var(--text-main);\n}\n\n.tip-content p {\n  margin: 0 0 12px;\n}\n\n.tip-content p:last-child {\n  margin-bottom: 0;\n}\n\n.tip-content ul,\n.tip-content ol {\n  margin: 0 0 12px 18px;\n  color: var(--text-main);\n}\n\n.tip-content li {\n  margin-bottom: 6px;\n}\n\n.tip-content strong,\n.tip-content b {\n  color: var(--text-strong);\n}\n\n.tip-content a,\n.tip-content a:link,\n.tip-content a:visited {\n  color: var(--brand-link) !important;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.tip-cardFooter {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 2px;\n}\n\n.tip-widgetEmpty {\n  padding: 10px 2px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-muted);\n}\n\n.whatsnew,\n.whatsnew .wn-grid,\n.whatsnew .wn-card {\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  min-width: 0;\n}\n\n.whatsnew .wn-img,\n.whatsnew .wn-burst {\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.tip-cardEyebrowWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.tip-cardIcon {\n  width: 26px;\n  height: 26px;\n  flex: 0 0 26px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: rgba(34, 126, 189, 0.1);\n  color: var(--brand-link);\n  border: 1px solid rgba(34, 126, 189, 0.12);\n}\n\n.tip-cardIcon svg {\n  width: 15px;\n  height: 15px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ==========================================================================\n   11) BUTTONS / LIBRARY\n   ========================================================================== */\n\n.primary-cta-btn,\n.manage-clubs-btn {\n  width: auto;\n  min-width: 0;\n  padding: 0 14px;\n  height: 36px;\n  border-radius: var(--radius-md, 8px);\n  background: var(--brand-link) !important;\n  border: 1px solid var(--brand-link) !important;\n  color: #fff !important;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: transform 0.06s ease, box-shadow 0.2s ease, background-color 0.2s ease, filter 0.2s ease;\n  box-shadow: var(--cta-shadow);\n}\n\n.primary-cta-btn:hover,\n.manage-clubs-btn:hover {\n  filter: brightness(0.95);\n  box-shadow: var(--cta-shadow-hover);\n}\n\n.primary-cta-btn:active,\n.manage-clubs-btn:active {\n  transform: translateY(1px);\n}\n\n.primary-cta-btn:focus,\n.manage-clubs-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.25);\n}\n\n.widget-library {\n  margin-top: 18px;\n  padding: 16px 18px;\n  border: 1px solid var(--line-soft);\n  border-radius: var(--radius-md, 8px);\n  background: linear-gradient(180deg, #ffffff, #fbfdff);\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);\n}\n\n.widget-libraryHeader {\n  margin-bottom: 12px;\n}\n\n.widget-libraryTitle {\n  font-size: 16px;\n  line-height: 1.2;\n  font-weight: 800;\n  color: var(--text-strong);\n}\n\n.widget-librarySubtitle {\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text-muted);\n}\n\n.widget-libraryList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.widget-libraryBtn {\n  min-height: 36px;\n  padding: 0 14px;\n  border-radius: 999px;\n  border: 1px solid var(--pill-blue-border-strong);\n  background: #f8fbff;\n  color: var(--brand-link);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.widget-libraryBtn:hover {\n  background: #eef6fb;\n  border-color: var(--pill-blue-border-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.1);\n}\n\n.widget-libraryBtn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n\n.widget-libraryBtn:active {\n  transform: translateY(0);\n}\n\n/* ==========================================================================\n   12) DARK MODE\n   ========================================================================== */\n\n[data-theme='dark'] .house-card {\n  background: #1a1c20;\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.08);\n  box-shadow: none;\n}\n\n[data-theme='dark'] .house-logo {\n  background: transparent;\n}\n\n[data-theme='dark'] .house-bar {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n[data-theme='dark'] .house-bar-fill {\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0.35), rgba(255, 255, 255, 0.7));\n}\n\n.school-card-actionIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 15px;\n  height: 15px;\n  flex: 0 0 auto;\n}\n\n.school-card-actionIcon svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.school-card-badge--action {\n  gap: 6px;\n  border-radius: var(--radius-md, 8px);\n}\n\n.primary-cta-btn,\n.widget-libraryBtn,\n.widget-libraryRestore {\n  border-radius: var(--radius-md, 8px) !important;\n  letter-spacing: 0 !important;\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.widget-drag-handle {\n  pointer-events: none;\n  pointer-events: none;\n  touch-action: none;\n}\n\n/* Design-system alignment overrides */\n.dashboard,\n.dashboard button,\n.dashboard input,\n.dashboard select,\n.dashboard textarea {\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.dashboard {\n  color: var(--text-body, #334155);\n}\n\n.widget-header h4,\n.widget-libraryTitle,\n.school-card-title,\n.profile-card-title,\n.statistics-widget .stat-value,\n.house-card-title {\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', 'Public Sans', system-ui, sans-serif));\n  color: var(--text-strong, #0f172a);\n  font-weight: var(--weight-bold, 700);\n  letter-spacing: var(--tracking-tight, -0.012em);\n}\n\n.dashboard-introSubtitle,\n.widget-librarySubtitle,\n.school-card-label,\n.profile-card-label,\n.empty-state-text,\n.dashboardPagerText {\n  color: var(--text-muted, #64748b);\n}\n\n.widget {\n  background: var(--surface-card, #ffffff);\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.widget:hover {\n  border-color: var(--border-default, #cbd5e1);\n  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));\n}\n\n.widget-header {\n  cursor: grab;\n  min-height: 56px;\n  background: var(--surface-card, #ffffff);\n  border-bottom-color: var(--border-subtle, #e2e8f0);\n}\n\n.widget-drag-handle,\n.widget-remove,\n.dashboardPagerBtn {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--slate-0, #ffffff);\n  color: var(--text-muted, #64748b);\n  border-radius: var(--radius-md, 8px);\n}\n\n.widget-dragIcon span {\n  background: var(--text-subtle, #94a3b8);\n}\n\n.widget-header:hover .widget-drag-handle {\n  pointer-events: none;\n  color: var(--text-body, #334155);\n  border-color: var(--blue-300, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n}\n\n.primary-cta-btn,\n.manage-clubs-btn {\n  height: var(--control-h-md, 38px);\n  padding: 0 var(--space-5, 16px);\n  border-radius: var(--radius-md, 8px) !important;\n  background: var(--action-primary, #227ebd) !important;\n  border-color: var(--action-primary, #227ebd) !important;\n  color: var(--text-on-brand, #ffffff) !important;\n  font-size: var(--text-md, 14px);\n  font-weight: var(--weight-semibold, 600);\n  letter-spacing: var(--tracking-normal, 0) !important;\n  box-shadow: none;\n  gap: var(--space-3, 8px);\n}\n\n.primary-cta-btn:hover,\n.manage-clubs-btn:hover {\n  background: var(--action-primary-hover, #1a6da3) !important;\n  border-color: var(--action-primary-hover, #1a6da3) !important;\n  filter: none;\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);\n}\n\n.primary-cta-btn:focus,\n.manage-clubs-btn:focus,\n.widget-libraryBtn:focus,\n.widget-libraryRestore:focus,\n.school-card-badge--action:focus,\n.profile-card-badge--action:focus {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.35));\n}\n\n.widget-library {\n  background: var(--surface-card, #ffffff);\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.widget-libraryBtn,\n.widget-libraryRestore,\n.school-card-badge,\n.profile-card-badge {\n  min-height: var(--control-h-sm, 32px);\n  border-radius: var(--radius-pill, 999px);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n  letter-spacing: var(--tracking-normal, 0);\n}\n\n.widget-libraryBtn,\n.widget-libraryRestore,\n.school-card-badge--action,\n.profile-card-badge--action {\n  background: var(--slate-0, #ffffff);\n  border: 1px solid var(--border-default, #cbd5e1);\n  color: var(--blue-600, #1a6da3) !important;\n}\n\n.widget-libraryBtn:hover,\n.widget-libraryRestore:hover,\n.school-card-badge--action:hover,\n.profile-card-badge--action:hover {\n  background: var(--blue-50, #eef6fc);\n  border-color: var(--blue-300, #6fb1df);\n  color: var(--blue-700, #155d8c) !important;\n  box-shadow: none;\n  transform: none;\n}\n\n.school-card-badge:not(.school-card-badge--action),\n.profile-card-badge:not(.profile-card-badge--action) {\n  background: var(--status-neutral-bg, #f1f5f9);\n  border-color: transparent;\n  color: var(--status-neutral-fg, #475569);\n}\n\n.school-card-badge--subtle,\n.profile-card-badge--subtle {\n  color: var(--text-muted, #64748b);\n}\n\n.statistics-widget .stat-row,\n.house-card,\n.tournament-card,\n.empty-state,\n.school-card-widget,\n.profile-card-widget {\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n}\n\n.statistics-widget .stat-icon,\n.school-card-actionIcon,\n.tip-cardIcon {\n  color: var(--blue-600, #1a6da3);\n}\n/* ==========================================================================`r`n   13) DESIGN SYSTEM ALIGNMENT OVERRIDES\n   Keep this last: it maps dashboard-specific controls back to squad-theme tokens.\n   ========================================================================== */\n\n.dashboard-viewport,\n.dashboard-viewport button,\n.dashboard-viewport input,\n.dashboard-viewport select,\n.dashboard-viewport textarea {\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n  color: var(--text-body, #334155);\n}\n\n.widget-header h4,\n.school-card-title,\n.profile-card-title,\n.widget-libraryTitle,\n.house-card-title,\n.stat-value,\n.tip-cardTitle {\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  color: var(--text-strong, #0f172a);\n  font-weight: var(--weight-bold, 700);\n  letter-spacing: var(--tracking-normal, 0);\n}\n\n.dashboard-introSubtitle,\n.widget-librarySubtitle,\n.school-card-label,\n.profile-card-label,\n.empty-list,\n.dashboardPagerText {\n  color: var(--text-muted, #64748b);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-medium, 500);\n}\n\n.widget {\n  background: var(--surface-card, #ffffff);\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.widget:hover {\n  border-color: var(--border-default, #cbd5e1);\n  box-shadow: var(--shadow-md, 0 4px 12px rgba(15, 23, 42, 0.08));\n}\n\n.widget-header {\n  background: var(--surface-card, #ffffff);\n  border-bottom-color: var(--border-subtle, #e2e8f0);\n}\n\n.widget-drag-handle,\n.widget-remove,\n.dashboardPagerBtn {\n  background: var(--surface-card, #ffffff);\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-muted, #64748b);\n  border-radius: var(--radius-md, 8px);\n  box-shadow: none;\n}\n\n.widget-drag-handle:hover,\n.dashboardPagerBtn:hover:not(:disabled) {\n  background: var(--surface-hover, #f1f5f9);\n  border-color: var(--border-default, #cbd5e1);\n  color: var(--text-strong, #0f172a);\n  box-shadow: none;\n}\n\n.widget-dragIcon span {\n  background: currentColor;\n}\n\n.widget-remove:hover {\n  background: var(--red-50, #fdecee);\n  border-color: var(--red-100, #f9d4d9);\n  color: var(--red-700, #a52836);\n  box-shadow: none;\n}\n\n.widget-drag-handle:focus,\n.widget-remove:focus,\n.dashboardPagerBtn:focus,\n.primary-cta-btn:focus,\n.manage-clubs-btn:focus,\n.widget-libraryBtn:focus,\n.widget-libraryRestore:focus {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.35));\n}\n\n.primary-cta-btn,\n.manage-clubs-btn {\n  height: var(--control-h-md, 38px);\n  padding: 0 var(--space-5, 16px);\n  border-radius: var(--radius-md, 8px) !important;\n  border: 1px solid var(--action-primary, #227ebd) !important;\n  background: var(--action-primary, #227ebd) !important;\n  color: var(--text-on-brand, #ffffff) !important;\n  font-size: var(--text-md, 14px);\n  font-weight: var(--weight-semibold, 600);\n  letter-spacing: var(--tracking-normal, 0) !important;\n  box-shadow: none;\n  gap: var(--space-3, 8px);\n}\n\n.primary-cta-btn:hover,\n.manage-clubs-btn:hover {\n  background: var(--action-primary-hover, #1a6da3) !important;\n  border-color: var(--action-primary-hover, #1a6da3) !important;\n  filter: none;\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.28);\n}\n\n.widget-library {\n  background: var(--surface-card, #ffffff);\n  border-color: var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n\n.widget-libraryBtn,\n.widget-libraryRestore,\n.school-card-badge--action,\n.profile-card-badge--action {\n  min-height: var(--control-h-sm, 32px);\n  padding: 0 var(--space-4, 12px);\n  border-radius: var(--radius-md, 8px) !important;\n  background: var(--surface-card, #ffffff);\n  border: 1px solid var(--border-default, #cbd5e1);\n  color: var(--text-link, #1a6da3) !important;\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n  letter-spacing: var(--tracking-normal, 0) !important;\n  box-shadow: none;\n}\n\n.widget-libraryBtn:hover,\n.widget-libraryRestore:hover,\n.school-card-badge--action:hover,\n.profile-card-badge--action:hover {\n  background: var(--blue-50, #eef6fc);\n  border-color: var(--blue-300, #6fb1df);\n  color: var(--blue-700, #155d8c) !important;\n  transform: none;\n  box-shadow: none;\n  text-decoration: none !important;\n}\n\n.school-card-badge,\n.profile-card-badge,\n.metric-pill,\n.house-points-badge,\n.stat-pill {\n  border-radius: var(--radius-pill, 999px);\n  background: var(--status-neutral-bg, #f1f5f9);\n  border-color: var(--border-subtle, #e2e8f0);\n  color: var(--status-neutral-fg, #475569);\n  font-size: var(--text-xs, 12px);\n  font-weight: var(--weight-semibold, 600);\n  letter-spacing: var(--tracking-normal, 0);\n}\n\n.school-card-badge:not(.school-card-badge--subtle),\n.profile-card-badge:not(.profile-card-badge--subtle) {\n  background: var(--blue-50, #eef6fc);\n  border-color: var(--blue-100, #d4e8f6);\n  color: var(--blue-700, #155d8c);\n}\n\n.dashboardEventRow,\n.tournament-card,\n.stat-card,\n.house-card,\n.tip-card {\n  border-radius: var(--radius-lg, 12px);\n  color: var(--text-body, #334155);\n}\n\n.dashboardEventTime,\n.school-card-eyebrow,\n.profile-card-eyebrow,\n.metric-label,\n.stat-label,\n.tip-cardEyebrow {\n  color: var(--text-muted, #64748b);\n  font-size: var(--text-xs, 12px);\n  font-weight: var(--weight-bold, 700);\n  letter-spacing: var(--tracking-caps, 0.06em);\n}\n\n.dashboardEventName,\n.tournament-name,\n.house-name,\n.school-card-value,\n.profile-card-value {\n  color: var(--text-strong, #0f172a);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n}\n\n.school-card-actionIcon,\n.statistics-widget .stat-icon,\n.tip-cardIcon {\n  color: var(--text-link, #1a6da3);\n}\n\n.dashboard-widget-list--sortable .dashboard-item--chosen .widget {\n  border-color: var(--border-brand, #227ebd);\n  box-shadow: var(--shadow-lg, 0 12px 28px rgba(15, 23, 42, 0.12));\n}\n\n.dashboard-widget-list--sortable .dashboard-item--ghost {\n  opacity: 0.45;\n}\n\n.dashboard-widget-list--sortable .dashboard-item--dragging {\n  opacity: 0.96;\n  break-inside: avoid;\n}\n\n.sortable-fallback.dashboard-item {\n  width: 304px !important;\n  list-style: none;\n}\n\n@media (min-width: 1500px) {\n  .sortable-fallback.dashboard-item {\n    width: 320px !important;\n  }\n}\n\n.dashboard-widget-list--native .dashboard-item {\n  cursor: default;\n}\n\n.dashboard-widget-list--native .dashboard-item--dragging {\n  opacity: 0.42;\n}\n\n.dashboard-widget-list--native .widget-headerMain {\n  cursor: grab;\n}\n\n.dashboard-widget-list--dragging .widget-headerMain {\n  cursor: grabbing;\n}\n\n/* Dashboard polish: action controls, important cards, schedule rows */\n.dashboard-actionBtn,\n.dashboard-actionBtn:link,\n.dashboard-actionBtn:visited {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: var(--control-h-sm, 32px);\n  padding: 0 var(--space-4, 12px);\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid var(--border-default, #cbd5e1);\n  background: var(--surface-card, #ffffff);\n  color: var(--text-link, #1a6da3) !important;\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n  line-height: 1;\n  letter-spacing: var(--tracking-normal, 0);\n  text-decoration: none !important;\n  box-shadow: none;\n  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.dashboard-actionBtn:hover,\n.dashboard-actionBtn:focus {\n  background: var(--blue-50, #eef6fc);\n  border-color: var(--blue-300, #6fb1df);\n  color: var(--blue-700, #155d8c) !important;\n  text-decoration: none !important;\n}\n\n.dashboard-iconBtn,\n.dashboard-iconBtn:link,\n.dashboard-iconBtn:visited {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--control-h-sm, 32px);\n  height: var(--control-h-sm, 32px);\n  padding: 0;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid var(--border-default, #cbd5e1);\n  background: var(--surface-card, #ffffff);\n  color: var(--text-link, #1a6da3) !important;\n  text-decoration: none !important;\n  box-shadow: none;\n  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.dashboard-iconBtn:hover,\n.dashboard-iconBtn:focus {\n  background: var(--blue-50, #eef6fc);\n  border-color: var(--blue-300, #6fb1df);\n  color: var(--blue-700, #155d8c) !important;\n}\n\n.dashboard-actionBtn:focus,\n.dashboard-iconBtn:focus {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.35));\n}\n\n.school-card-actions,\n.profile-card-actions {\n  align-items: center;\n  gap: var(--space-3, 8px);\n}\n\n.profile-card-badge {\n  text-transform: none;\n}\n\n.school-card-actionIcon,\n.school-card-actionIcon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.widget .important-event-card,\n.widget .important-event-card:link,\n.widget .important-event-card:visited {\n  grid-template-columns: 38px minmax(0, 1fr) auto;\n  gap: var(--space-3, 8px);\n  padding: var(--space-3, 8px) var(--space-4, 12px);\n  border-radius: var(--radius-lg, 12px);\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #ffffff);\n  box-shadow: none;\n}\n\n.widget .important-event-card:hover {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-hover, #f8fafc);\n  box-shadow: none;\n  transform: none;\n}\n\n.important-event-cardIcon {\n  width: 38px;\n  height: 38px;\n  display: inline-grid;\n  place-items: center;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid transparent;\n}\n\n.important-event-cardIcon svg {\n  width: 18px;\n  height: 18px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.important-event-card--requests .important-event-cardIcon {\n  background: var(--blue-50, #eef6fc);\n  border-color: var(--blue-100, #d4e8f6);\n  color: var(--blue-700, #155d8c);\n}\n\n.important-event-card--invites .important-event-cardIcon {\n  background: var(--green-50, #ecfdf3);\n  border-color: var(--green-100, #d1fadf);\n  color: var(--green-700, #047857);\n}\n\n.important-event-card--tournaments .important-event-cardIcon {\n  background: var(--amber-50, #fffbeb);\n  border-color: var(--amber-100, #fef3c7);\n  color: var(--amber-700, #b45309);\n}\n\n.important-event-cardCount {\n  min-width: 28px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n  font-size: var(--text-xs, 12px);\n  font-weight: var(--weight-bold, 700);\n  box-shadow: none;\n}\n\n.important-event-cardTitle {\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n}\n\n.important-event-cardMeta {\n  color: var(--text-muted, #64748b);\n  font-size: var(--text-xs, 12px);\n}\n\n.dashboardScheduleRow,\n.dashboardScheduleRow:link,\n.dashboardScheduleRow:visited {\n  display: grid !important;\n  grid-template-columns: 72px minmax(0, 1fr);\n  gap: var(--space-3, 8px);\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  padding: 9px 0;\n  color: var(--text-body, #334155) !important;\n  text-decoration: none !important;\n}\n\n.dashboardScheduleRow:hover {\n  text-decoration: none !important;\n}\n\n.dashboardScheduleBlock {\n  min-width: 0;\n  min-height: 48px;\n  padding: 7px 8px;\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid var(--blue-100, #d4e8f6);\n  background: var(--blue-50, #eef6fc);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.dashboardScheduleEyebrow {\n  font-size: 10px;\n  line-height: 1.1;\n  font-weight: var(--weight-bold, 700);\n  letter-spacing: var(--tracking-caps, 0.06em);\n  text-transform: uppercase;\n  color: var(--text-muted, #64748b);\n}\n\n.dashboardScheduleDate {\n  margin-top: 2px;\n  font-size: var(--text-sm, 13px);\n  line-height: 1.1;\n  font-weight: var(--weight-bold, 700);\n  color: var(--blue-700, #155d8c);\n}\n\n.dashboardScheduleTime {\n  margin-top: 2px;\n  font-size: var(--text-xs, 12px);\n  line-height: 1.1;\n  font-weight: var(--weight-bold, 700);\n  color: var(--text-strong, #0f172a);\n  font-variant-numeric: tabular-nums;\n}\n\n.dashboardScheduleMain {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboardScheduleName {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--text-strong, #0f172a);\n  font-size: var(--text-sm, 13px);\n  font-weight: var(--weight-semibold, 600);\n  line-height: 1.25;\n}\n\n.dashboardScheduleMeta {\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: var(--text-xs, 12px);\n  line-height: 1.3;\n}\n\n.tip-cta-btn {\n  text-transform: none !important;\n}\n.dashboard-setupBanner {\n  display: flex;\n  justify-content: space-between;\n  gap: 18px;\n  align-items: center;\n  margin-bottom: 18px;\n  border: 1px solid #b9d8ec;\n  border-radius: 12px;\n  background: #eef7fc;\n  padding: 16px 18px;\n}\n\n.dashboard-setupBanner strong,\n.dashboard-setupBanner span {\n  display: block;\n}\n\n.dashboard-setupBanner strong {\n  color: #153e63;\n}\n\n.dashboard-setupBanner span {\n  margin-top: 4px;\n  color: #567188;\n  font-size: 13px;\n}\n\n.dashboard-setupBanner a {\n  flex: 0 0 auto;\n  border-radius: 8px;\n  background: #17699c;\n  color: #fff;\n  padding: 9px 14px;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n@media (max-width: 640px) {\n  .dashboard-setupBanner {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .dashboard-setupBanner a {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
